import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import {makeOtherBoItems} from "../helpers/other-bo-items.js";

export default function OtherBo({ title, data}) {
    const bo = makeOtherBoItems(data);

    return (
        <InfoGrid title={title} items={bo} columns={1} />
    )
}